import { Spinner } from '@savvy-kit/components/spinner';

export const CLIENT_PORTAL_VERSION_PENDING_TESTID = 'client-portal-version-pending';

export function ClientPortalVersionPending() {
  return (
    <div
      className="flex min-h-screen flex-grow items-center justify-center bg-background"
      data-testid={CLIENT_PORTAL_VERSION_PENDING_TESTID}
    >
      <Spinner className="size-12" />
    </div>
  );
}
